// 国家地区Code转区号Code
export default {
  cn: 'CN', // 中国
  hk: 'HK', // 香港
  en: 'HK', // 美国（用香港区号）
  id: 'ID' // 印度尼西亚
};
